import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OcDatePicker } from "oc/components";
import { getDateFormatByLocale } from "oc/utils";

interface OcFormEditorValidFromSelectorProps {
  name: string;
  value: Date | null;
  label: string;
  onChange: (name: string, date: Date | null) => void;
  def?: { type?: string };
}

export const OcFormEditorValidFromSelector: React.FC<
  OcFormEditorValidFromSelectorProps
> = ({ name, value, label, onChange, def }) => {
  const { t, i18n } = useTranslation();
  const handleChange = (date: Date | null) => {
    onChange(name, date);
  };

  let minDate: Date | undefined = undefined;
  if (
    def?.type === "permanentAddress" ||
    def?.type === "temporaryAddress" ||
    def?.type === "serviceAddress"
  ) {
    minDate = new Date();
  }
  return (
    <Box paddingTop="36px">
      <OcDatePicker
        id={name}
        label={t(label)}
        onChange={handleChange}
        value={value}
        minDate={minDate}
        format={getDateFormatByLocale(i18n.language)}
      />
    </Box>
  );
};

export default OcFormEditorValidFromSelector;
